import { useNavigate } from 'react-router';

import { useMenu } from '@jane/shared-ecomm/providers';

export const useFullyReplaceCart = ({ cartUuid }: { cartUuid?: string }) => {
  const navigate = useNavigate();
  const {
    dispatches: { getRemoteCart },
    paths,
  } = useMenu();

  const fullyReplaceCart = () => {
    cartUuid && getRemoteCart(cartUuid, () => navigate(paths.checkout()));
  };

  return { fullyReplaceCart };
};
